import { render, staticRenderFns } from "./DialogFeedbackForm.vue?vue&type=template&id=3f8b0dde&scoped=true&"
import script from "./DialogFeedbackForm.vue?vue&type=script&lang=js&"
export * from "./DialogFeedbackForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8b0dde",
  null
  
)

export default component.exports